<div class="flex flex-col gap-8">
  <div>
    <h4 class="font-medium">Facilities</h4>
    <p class="text-surface-500">
      View the indicators and details of each facility.
    </p>
  </div>

  @if (exportMode()) {
    <div [class]="exportGridCols()">
      @for (chart of summaryChartsWithNullValues(); track $index) {
        @if (chart) {
          <selectable-widget
            #sw
            [exportMode]="true"
            [selected]="isWidgetSelected(sw.nativeEl)"
            (widgetToggle)="
              widgetToggle.emit({ checked: $event, el: sw.nativeEl })
            ">
            <summary-chart
              [data]="chart"
              [currency]="displayCurrency()"
              [routerLink]="chart.route"
              [chartWidth]="'100%'"
              [style.max-width]="'100%'"
              [style.height]="'100%'"
              [attr.analytics-label]="
                { element: 'summary-chart', action: 'open_facility' }
                  | analyticsLabelValue
              " />
          </selectable-widget>
        }
      }
    </div>
  } @else {
    <p-carousel
      [value]="summaryChartsWithNullValues()"
      [numVisible]="carouselNumVisibleScroll()"
      [numScroll]="carouselNumVisibleScroll()"
      class="summary_carrousel">
      <ng-template let-chart pTemplate="item">
        @if (chart) {
          <summary-chart
            [data]="chart"
            [currency]="displayCurrency()"
            [routerLink]="chart.route"
            [chartWidth]="'100%'"
            [style.max-width]="'100%'"
            [style.height]="'100%'"
            [attr.analytics-label]="
              { element: 'summary-chart', action: 'open_facility' }
                | analyticsLabelValue
            " />
        }
      </ng-template>
    </p-carousel>
  }
</div>
